import { styled } from '@mui/material/styles';

export const ProfilePicture = styled(`img`)(({ alt }) => ({
  alt: alt ?? `Profile picture`,
  maxWidth: 320,
  maxHeight: 180,
  marginBottom: `1rem`,
}));
